import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GovernanceReportComponent } from './governance-report.component';

const routes: Routes = [
  {
    path: '', component: GovernanceReportComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GovernanceReportRoutingModule { }
